// ES
export const availabilityPrices = {
  header: {
    title: "Disponibilidad & Tarifas",
  },
  common: {
    today: "Hoy",
    cancel: "Cancelar",
    save: "Guardar",
    saving: "Guardando…",
  },
  pricelabs: {
    title: "Los precios están siendo gestionados por PriceLabs",
    text: "Las tarifas son actualizadas automáticamente y no se pueden editar manualmente.",
  },
  topbar: {
    calendar: "Calendario",
    bulkEdit: "Edición masiva",
    configTitle: "Configuración del calendario",
    syncSection: "Sincronización",
    resyncOta: "Re-sincronizar con OTA",
    resyncOtaDesc: "Reenvía disponibilidad y tarifas al canal.",
  },
  empty: {
    noHotelTitle: "Sin anuncios de tipo hotel",
    noHotelDesc:
      "Crea un anuncio de tipo <strong>Hotel</strong> o <strong>Camping</strong> para comenzar a gestionar disponibilidad y tarifas.",
    goToListings: "Ir a anuncios",
    noRoomsTitle: "{name} no tiene habitaciones",
    noRoomsDesc:
      "Este anuncio aún no tiene habitaciones registradas. Añade unidades desde el detalle del anuncio para gestionar disponibilidad y tarifas.",
    configureListing: "Configurar anuncio",
  },
  summary: {
    roomState: "Estado de la habitación",
    roomsForSale: "Habitaciones a la venta",
    netBooked: "Reservado neto",
  },
  state: {
    available: "Disponible",
    closed: "Cerrado",
    soldOut: "Se han vend.",
    pastLabel: "No disp.",
  },
  calendar: {
    // Pluralización (vue-i18n v8 con pipes) — choiceIndex = nº de habitaciones / noches
    roomsCount: "{count} habitación | {count} habitaciones",
    minStayTooltip: "Estancia mínima: {count} noche | Estancia mínima: {count} noches",
  },
  offBadge: "APAGADA",
  offTooltip: "Venta apagada: esta tarifa no se ofrece en ningún canal. Las demás tarifas de la habitación siguen vendiéndose.",
  rateMenu: {
    open: "Opciones de la tarifa",
    minStay: "Estancia mínima por fechas",
    priceLabsMinStay: "Esta tarifa la gestiona PriceLabs: su estancia mínima la pone él.",
    stopSelling: "Apagar la venta de esta tarifa",
    stopping: "Apagando la venta…",
    resuming: "Reactivando la venta…",
    resumeSelling: "Reactivar la venta de esta tarifa",
    derivedPriceHint: "El precio de una tarifa derivada sale de su principal",
    mainKeepsDerived: "Sus tarifas derivadas seguirán vendiéndose",
    mainNotYet: "Apagar una tarifa principal todavía no está disponible",
  },
  derived: {
    badge: "D",
    tooltip: "Tarifa derivada de: {parent}{rule}",
    rulePart: " · Regla: {rule}",
  },
  tooltips: {
    syncEnabled:
      "Recalcula y reenvía a la OTA la disponibilidad y la estancia máxima (evita overbooking).",
    syncDisabled: "Conecta la propiedad con un canal para poder sincronizar.",
    toggleClosedOpen: "Alternar cerrado/abierto",
    managedByPricelabs: "Gestionado por PriceLabs",
    clickToEdit: "Selecciona o haz click para editar",
  },
  cellTitle: {
    seasonClosed: "Cerrado por la temporada «{name}» (se abre editando la temporada)",
    pastDate: "Fecha pasada",
    closed: "Cerrado (click para abrir)",
    detail:
      "{free} libres · ofreces {tope} de {total} · {booked} reservadas — click para editar el tope",
  },
  soldBadge: {
    confirmed: "{real} reservas confirmadas",
    withOverbooking: "{real} confirmadas + {over} en overbooking",
  },
  bulkModal: {
    from: "Desde",
    to: "Hasta",
    rangeHint:
      "Puedes editar el rango aquí para ampliarlo o ajustarlo. (La vista solo actualizará visualmente el mes actual.)",
    room: "Habitación",
    whatToEdit: "Qué editar",
    optAvail: "Disponibilidad y cierres",
    optRate: "Precios y estancia mínima",
    status: "Estado",
    open: "Abrir",
    close: "Cerrar",
    cap: "tope",
    availHint:
      "Es el total que ofreces; las reservas se descuentan solas y se vende lo libre. Máx. {max} (operativas, sin mantenimiento).",
    mainRate: "Tarifa principal",
    mainRateHint:
      "Elige la tarifa principal a cambiar; sus tarifas derivadas se ajustan solas.",
    action: "Acción",
    price: "Precio",
    minStay: "Estancia mínima",
    minStayNights: "Estancia mínima (noches)",
    minStayHelp: "1 = sin restricción (limpiar)",
  },
  syncConfirm: {
    title: "Sincronizar con la OTA",
    message:
      "Se recalculará y reenviará la disponibilidad y la estancia máxima de este calendario a la OTA.",
    confirm: "Sí, sincronizar",
  },
  progress: {
    processing: "Procesando…",
    syncing: "Sincronizando calendario con la OTA…",
    updatingAvail: "Actualizando disponibilidad…",
    updatingRate: "Actualizando tarifa…",
    applying: "Aplicando cambios…",
    applyingBulk: "Aplicando edición masiva…",
    applyingIn: "Aplicando en {name}…",
  },
  toasts: {
    noPropertyToSync: "No hay propiedad para sincronizar.",
    syncOk: "Calendario recalculado y sincronizado con la OTA.",
    syncErr: "No se pudo sincronizar el calendario con la OTA.",
    loadErr: "No se pudo cargar la información del hotel.",
    maxAvailClosedBlocked:
      "Máximo disponible: {capacity} (hay habitaciones cerradas, bloqueadas o en mantenimiento).",
    availUpdated: "Disponibilidad actualizada",
    availUpdateErr: "No se pudo actualizar la disponibilidad",
    freeSuffix: " (libres: {free})",
    rateUpdated: "Tarifa actualizada",
    rateUpdateErr: "No se pudo actualizar la tarifa",
    maxAvailMaintenance:
      "Máximo disponible: {capacity} (hay habitaciones en mantenimiento o no operativas).",
    noDatesModifiedBooked: "No se modificó ninguna fecha: {count} con reservas.",
    appliedFreeDates:
      "Aplicado a las fechas libres. {count} fecha(s) con reservas no se modificaron.",
    changesApplied: "Cambios aplicados correctamente",
    savedNotSyncedYet: "Guardado aquí, pero todavía no llegó a los canales de venta. Se reintenta solo en unos minutos.",
    cannotEditDerivedPricelabs:
      "No se puede editar una tarifa derivada o gestionada por PriceLabs.",
    minStayNumberGte1: "La estancia mínima debe ser un número >= 1.",
    invalidAction: "Acción inválida.",
    applyErr: "No se pudieron aplicar los cambios",
    noRoomsToEdit: "No hay habitaciones para editar.",
    selectAtLeastOneRoom: "Selecciona al menos una habitación.",
    chooseAction: "Elige una acción.",
    selectDateRange: "Selecciona un rango de fechas.",
    enterValidPrice: "Indica un precio válido.",
    minStayGte1: "La estancia mínima debe ser >= 1.",
    appliedWithErrors: "Aplicado en {ok} habitación(es). {failed} con error",
    noDatesModifiedCapacity:
      "No se modificó ninguna fecha: {count} día(s) no admitían ese número de habitaciones.",
    bulkAppliedClamped:
      "Edición masiva aplicada en {ok} habitación(es). En {clamped} fecha(s) se ajustó al número de habitaciones en servicio.",
    bulkApplied: "Edición masiva aplicada en {ok} habitación(es).",
    bulkApplyErr: "No se pudo aplicar la edición masiva.",
    applyChangesErr: "No se pudieron aplicar los cambios.",
  },
  // Contenido decorativo (aria-hidden) del estado vacío
  ghost: {
    month: "MAYO DE 2026",
    day1: "lun 1",
    day2: "mar 2",
    day3: "mié 3",
    day4: "jue 4",
    day5: "vie 5",
    day6: "sáb 6",
    day7: "dom 7",
    day8: "lun 8",
    day9: "mar 9",
    day10: "mié 10",
    day11: "jue 11",
    day12: "vie 12",
    unit1: "Suite Deluxe",
    unit1Rooms: "(2 hab.)",
    unit2: "Habitación Estándar",
    unit2Rooms: "(3 hab.)",
    baseRate: "Tarifa Base",
    nonRefundable: "No Reembolsable",
  },
};
